// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2voNC","col":"styles_col__2-mWw","actions":"styles_actions__yDLyU","conflict":"styles_conflict__3Dinu"};